import { Component, OnInit, ViewChild, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent
} from "@angular/material/dialog";
import { AuditService } from "@app/services/http/audit.service";

import { GridComponent } from "@app/view/shared/base-pages/base-data-table-page/grid.component";
import { RowExpanderConfig } from "@bryntum/grid-thin";
import { BaseAuditViewer } from "@app/view/shared/audits/base/base-audit-viewer";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";
import { MatCheckbox } from "@angular/material/checkbox";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { GridComponent as GridComponent_1 } from "../../base-pages/base-data-table-page/grid.component";
import { DialogHeaderComponent } from "../../dialog-header/dialog-header.component";

@Component({
  selector: "app-resource-availability-audit-viewer",
  templateUrl: "./resource-availability-audit-viewer.component.html",
  styleUrls: ["./resource-availability-audit-viewer.component.css"],
  imports: [
    MatCheckbox,
    CdkScrollable,
    MatDialogContent,
    GridComponent_1,
    DialogHeaderComponent
  ]
})
export class ResourceAvailabilityAuditViewerComponent
  extends BaseAuditViewer
  implements OnInit
{
  dialogRef =
    inject<MatDialogRef<ResourceAvailabilityAuditViewerComponent>>(
      MatDialogRef
    );
  data = inject<{
    availabilityId: number;
  }>(MAT_DIALOG_DATA);
  auditService: AuditService;

  public rowExpanderConfig: Partial<RowExpanderConfig> = {
    columnPosition: "first",
    renderer: async ({ record }) => {
      console.log("Rendering expander for record ", record);
      let renderString = `<resource-availability-audit-renderer style="width:100%" snapshot-id="${
        record.get("majorId") + "." + record.get("minorId")
      }" availability-id="${record.get(
        "entityId"
      )}"></resource-availability-audit-renderer>`;
      console.log("renderString", renderString);
      return renderString;
    }
  };
  @ViewChild(GridComponent, { static: true }) auditGrid: GridComponent;

  constructor() {
    const auditService = inject(AuditService);

    super(auditService, "resourceAvailability");

    this.auditService = auditService;
  }

  ngOnInit(): void {
    this.queryAudit(
      this.data.availabilityId,
      "resourceAvailability",
      this.auditGrid
    );
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
}
